// Three
import * as THREE from 'three';

// Orthographic camera whose frustum matches the viewport in pixels, so 1px of
// DOM == 1 world unit. Screen center is the world origin; +Y is up.
export default class Camera {
	constructor({ sizes }) {
		this.el = new THREE.OrthographicCamera(
			sizes.width / -2,
			sizes.width / 2,
			sizes.height / 2,
			sizes.height / -2,
			1,
			1000
		);
		this.el.position.set(0, 0, 10);
	}

	resizeCamera(sizes) {
		this.el.left = sizes.width / -2;
		this.el.right = sizes.width / 2;
		this.el.top = sizes.height / 2;
		this.el.bottom = sizes.height / -2;
		this.el.updateProjectionMatrix();
	}
}
